<template>
    <aside class="vue-country-aside" :class="{'open': open, 'has-country': hasSelectedCountry}">
        <div class="inner-wrapper">
            <div class="inner">
                <button v-if="hasSelectedCountry" class="btn-toggle close-icon" @click="handleResetMap">{{ closeText }}</button>
                <button v-if="! hasSelectedCountry" class="btn-toggle" @click="handleClick">{{ filterTitle }}</button>

                <perfect-scrollbar>
                    <button class="reset-map" @click="handleResetMap">
                        <span :class="{'visually-hidden': hasSelectedCountry}">{{ backToMap }}</span>
                    </button>

                    <zoa-country-filters
                        v-if="! hasSelectedCountry"
                        :countries="countries"
                        :filter-text="filterText"
                        :event-bus="eventBus"
                        :reset-filters="resetFilters"
                        :countries-title="countriesTitle"
                        :specialisms-title="specialismsTitle"
                        :filter-title="filterTitle"
                    ></zoa-country-filters>

                    <zoa-selected-country
                        v-if="hasSelectedCountry"
                        :selected-country="selectedCountry"
                        :read-more-about="readMoreAbout"
                        :selected-country-help-title="selectedCountryHelpTitle"
                    ></zoa-selected-country>
                </perfect-scrollbar>
            </div>
        </div>
    </aside>
</template>

<script>
export default {
    name: "CountryAside",

    props: ['countries', 'eventBus', 'selectedCountry', 'filterText', 'filterTitle', 'backToMap', 'resetFilters', 'countriesTitle', 'specialismsTitle', 'readMoreAbout', 'selectedCountryHelpTitle'],

    data() {
        return {
            open: false,
            closeText: window.Drupal.t('Close')
        }
    },

    computed: {
        hasSelectedCountry() {
            return ! _.isNil(this.selectedCountry);
        }
    },

    mounted() {
        this.eventBus.$on('country-clicked', (payload) => {
            this.open = true;
        });

        this.eventBus.$on('close-aside', () => {
            this.open = false;
        });
    },

    methods: {
        handleClick() {
            this.open = ! this.open;

            setTimeout(() => {
                this.eventBus.$emit('resize-map');
            }, 150)
        },

        handleResetMap() {
            this.open = false;

            if (this.hasSelectedCountry) {
                this.eventBus.$emit('reset-focus');
                return;
            }

            setTimeout(() => {
                this.eventBus.$emit('resize-map');
            }, 150)
        }
    }
}
</script>